<template>
  <!-- A template is needed for a vuejs component but, 
  it's not used for this component, 
  so it will stay empty to not fail the test -->
  <div v-if="false"></div>
</template>
<script>
export default {
  name: 'tenant-custom-style',
  props: {
    cssString: {
      type: String,
    },
  },

  created() {
    //title used to not have ambiguity
    document.querySelectorAll('style[title="tenant-custom-css"]').forEach((node) => {
      node.remove();
    });
    const tenantCustomStyle = document.createElement('style');
    tenantCustomStyle.title = 'tenant-custom-css';
    tenantCustomStyle.innerHTML = this.cssString;
    document.head.appendChild(tenantCustomStyle);
  },
};
</script>
